import { takeLatest } from 'redux-saga/effects';
import AT from '../constants/action-types';
import { createQueue, updateQueue } from '../api';
import { handleFormSubmit } from './helpers/handle-api-form-call';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* processSaveQueue(action: any) {
  const { data, formikActions } = action;
  const { id, serviceProviderId } = data;
  yield handleFormSubmit({
    id,
    formikActions,
    updateFn: async () => updateQueue(id, { serviceProviderId, ...data }),
    createFn: async () => createQueue({ serviceProviderId, ...data })
  });
}

export default function* saveQueueSaga() {
  yield takeLatest(AT.SAVE_QUEUE_SAGA, processSaveQueue);
}
